import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import DashboardLayout from './DashboardLayout';
import { actions as uiActions } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { IApplicationState } from 'ducks/reducers';
import { selectors as dashboardMaintenanceSelectors, actions as dashboardMaintenanceActions } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => ({
    selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
    selectedDashboard: dashboardMaintenanceSelectors.selected(state),
    selectedDashboardType: dashboardMaintenanceSelectors.selected(state)?.DashboardType,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeOperationMode: operationActions.changeOperationMode,
        changeSelectedRecord: dashboardMaintenanceActions.setSelected
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayout);
